/**
 * Created by INF011 on 20/08/2016.
 */
import AjtAjax from './AjtAjaxAxios';
export default AjtAjax;